import { render, staticRenderFns } from "./ImportText.vue?vue&type=template&id=d9820bf8&"
import script from "./ImportText.vue?vue&type=script&lang=js&"
export * from "./ImportText.vue?vue&type=script&lang=js&"
import style0 from "./ImportText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports